// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"565":"c83e1164","4799":"d629cd3b","5487":"c83e1164","6048":"c83e1164","6067":"c83e1164","6579":"c83e1164","7931":"c83e1164","8092":"c83e1164","8637":"c83e1164","8762":"c83e1164","9723":"c83e1164"}[chunkId] + ".chunk.css";
};